<template>
  <div class="contacts-upload-brand-block">
    <button type="button" class="close" aria-label="Close" v-if="value" @click="() => $emit('input', false)">
      <span aria-hidden="true">&times;</span>
    </button>
    <slot name="icon">
      <div class="mt-3 mb-2 icon" v-if="icon" :class="{ 'icon-background': iconBackgroundColour }" :style="{ 'background-color': iconBackgroundColour, 'color': iconTextColor }">
        <font-awesome-icon :icon="[ 'fab', icon ]"/>
      </div>
    </slot>
    <slot name="title">
      <div class="title" v-if="titleText">{{ titleText }}</div>
    </slot>
    <slot name="last-connected">
      <!-- <p class="small-font p-0" v-if="lastConnected"></p>
      <p class="small-font p-0" v-else>Not yet connected</p> -->
      <p class="small-font p-0">&nbsp;</p>
    </slot>
    <b-btn class="pt-2" :style="{ 'background-color': buttonBackgroundColour, 'color': buttonTextColour }" variant="transparent"
      v-if="button && !value" @click="() => $emit('input', true)">{{ button }}</b-btn>
  </div>
</template>

<script>
export default {
  props: {
    titleText: {
      type: String,
      default: () => null,
    },
    icon: {
      type: String,
      default: () => null,
    },
    iconBackgroundColour: {
      type: String,
      default: () => null,
    },
    iconTextColor: {
      type: String,
      default: () => '#000',
    },
    button: {
      type: String,
      default: () => null,
    },
    buttonBackgroundColour: {
      type: String,
      default: () => null,
    },
    buttonTextColour: {
      type: String,
      default: () => '#000',
    },
    lastConnected: {
      type: String,
      default: () => null,
    },
    value: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>

<style lang="scss">
.contacts-upload-brand-block {
  position: relative;
  border-color: #dadada;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  height: 100%;
  text-align: center;

  padding: 15px;
  width: 100%;
  // opacity: 0.5;
  // &:hover {
  //   opacity: 1;
  //   .btn {
  //     opacity: 1;
  //   }
  // }

  &.active {
    border-top-width: 5px;
    border-top-style: solid;
    border-bottom-width: 0px;
    padding-top: 10px;
    // opacity: 1;
  }

  .close {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
    height: 40px;
    width: 40px;

    font-size: 22px;
    text-align: center;

    &.icon-background {
      border-radius: 50%;
    }
  }

  .btn {
    border-width: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contacts-upload/BrandBlock.vue